import React, { Component } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from '@fullcalendar/bootstrap';
import listPlugin from '@fullcalendar/list';
import timeGridPlugin from '@fullcalendar/timegrid';
import { Modal, Button} from 'react-bootstrap';
import { activateNoaSchedulingAlgorithm } from '../../UserFunctions';

// import { removeSurgery } from '../UserFunctions';
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';

// **** FOR DEVELOPMENT **** //
// const local_host = 'http://localhost:5000/surgeriessurgical';
const remote_host = 'https://server-soroka-demo.herokuapp.com/surgeries_surgical/get_all';


export class CalendarSurgical extends Component {
  temp = [];
  state = { surgeries: [], full_data_surgeries: [], isLoading: true,modalShow: null, setModalShow: null, info: null };
  colors_arr = ['#FFA07A','pink','#ADD8E6','#7FFFD4','#DDA0DD'];
  getSurgeries = () => {
    fetch(remote_host, {})
      .then(data => data.json())
      .then(data => {
        var surgeries_fetched = data.map(surgery => {
          return {
            title: surgery.description, 
            start: surgery.st_time, 
            end: surgery.end_time,
            color: this.colors_arr[surgery.room_id],
            extendedProps:{
              id : surgery.id,
              patient_id: surgery.patient_id,
              request_id: surgery.request_id,
              stagiaire_id: surgery.stagiaire_id,
              senior_id: surgery.senior_id,
              anesthetist_id: surgery.anesthetist_id,
              nurse_id: surgery.nurse_id,
              room_id: surgery.room_id
            }
          }
        })
        this.setState({ surgeries: surgeries_fetched, full_data_surgeries: data, isLoading: false, EventModalShow: false, NullifyEventModalShow: false })
        console.log(surgeries_fetched)
        console.log(data);
        
    })
      .catch(e => console.log(e));
  }


  eventClickFunc2 = () => {
    activateNoaSchedulingAlgorithm().then((res, err) => {
      if (res) {
        alert('Schedule is ready!')
      } else {
        alert('Schedule is ready!') // NEED TO FIX THIS ONE!!!
      }
  })
  }


    eventClickFunc = (info) => {
      

      this.setState({info: info, EventModalShow: true});
      console.log(this.state.info.event);
      info.jsEvent.preventDefault();
    }

    handleDateClick = (start, end, allDay) => { // Need to change Modal to eventClickFunc

      
      }

      componentDidMount() {
        this.getSurgeries();
        
      }

    render() {

      
      
      function MyVerticallyCenteredModalSurgery(props) {
        console.log(props);
        return (
          <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
              <h3 style={{ color: 'darkblue', fontWeight: 'bold' }}>Surgery Information</h3>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <h5>{!props.currinfo ? "ERROR" : "Request ID: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.extendedProps.request_id}
              <h5>{!props.currinfo ? "ERROR" : "Description: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.title}
              <h5>{!props.currinfo ? "ERROR" : "Patient ID: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.extendedProps.patient_id}
              <h5>{!props.currinfo ? "ERROR" : "Senior Surgeon ID: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.extendedProps.senior_id}
              <h5>{!props.currinfo ? "ERROR" : "Stagiaire Surgeon ID: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.extendedProps.stagiaire_id}
              <h5>{!props.currinfo ? "ERRPR" : "Anesthetist ID: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.extendedProps.anesthetist_id}
              <h5>{!props.currinfo ? "ERRPR" : "Nurse ID: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.extendedProps.nurse_id}
              <h5>{!props.currinfo ? "ERRPR" : "Room ID: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.extendedProps.room_id}
              <h5>{!props.currinfo ? "ERROR" : "Starting Time: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.start.toString()}
              <h5>{!props.currinfo ? "ERROR" : "Expected Ending Time: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.end.toString()}
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer>
          </Modal>
        );
      }

      

      // let NullifyModalClose = () => this.setState({NullifyModalShow: false});
      let EventModalClose = () => this.setState({EventModalShow: false, info: null});

        return (
          
          <div>
            
            <FullCalendar 
            editable='false'
            selectable='true' 
            dateClick={this.handleDateClick} 
            defaultView="timeGridWeek" 
            plugins={[ dayGridPlugin, bootstrapPlugin, interactionPlugin, listPlugin, timeGridPlugin ]} 
            events={this.state.surgeries}
            nowIndicator='true'
            eventClick={this.eventClickFunc}
            customButtons= {{
              add_event: {
                  text: 'Add Event',
                  click: function() {
                     window.location = '/calendar/addsurgery1';
                  }
              }
            }}
            header={{
              left: 'prev,next today,     add_event',
              center: 'title',
              right: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth'
            }}

            themeSystem = 'bootstrap'
            />

            <Button variant="danger" onClick={this.eventClickFunc2}>Activate Sheduling Algorithm!</Button>
            <MyVerticallyCenteredModalSurgery
              show={this.state.EventModalShow}
                onHide={EventModalClose}
                currinfo ={this.state.info}
            />
          
            </div>

        )
    }
}

export default CalendarSurgical